const items = [
    "Get found locally",
    "No more email threads",
    "Removing all friction",
    "Shops & suppliers, one platform",
    "Receive & track orders seamlessly",
    "Built for print",
];

export default function ValueMarquee() {
    return (
        <div className="pt-[32px] border-t border-[#e4e5e7] -mx-[16px] md:-mx-[40px]">
            <div
                className="value-marquee relative overflow-hidden"
                style={{
                    maskImage:
                        "linear-gradient(to right, transparent, black 8%, black 92%, transparent)",
                }}
            >
                <div className="value-marquee-track flex gap-[16px] w-max">
                    {[...items, ...items].map((item, index) => (
                        <div
                            key={index}
                            className="flex items-center gap-[10px] border border-[#f5e3c5] rounded-lg pl-[12px] pr-[18px] py-[10px] shrink-0 bg-white"
                        >
                            <svg width="16" height="16" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19 38C24.0391 38 28.8718 35.9982 32.435 32.435C35.9982 28.8718 38 24.0391 38 19C38 13.9609 35.9982 9.12818 32.435 5.56499C28.8718 2.0018 24.0391 1.75915e-05 19 1.66103e-05L19 19L19 38Z" fill="#FF5323" />
                                <path d="M19 38C24.0391 38 28.8718 35.9982 32.435 32.435C35.9982 28.8718 38 24.0391 38 19C38 13.9609 35.9982 9.12818 32.435 5.56499C28.8718 2.0018 24.0391 1.75915e-05 19 1.66103e-05L19 19L19 38Z" fill="url(#paint0_linear_22_5890)" />
                                <path d="M0 38C5.03911 38 9.87184 35.9982 13.435 32.435C16.9982 28.8718 19 24.0391 19 19C19 13.9609 16.9982 9.12816 13.435 5.56497C9.87184 2.00178 5.03912 9.81151e-07 4.52995e-06 0L0 38Z" fill="#FF5323" />
                                <path d="M0 38C5.03911 38 9.87184 35.9982 13.435 32.435C16.9982 28.8718 19 24.0391 19 19C19 13.9609 16.9982 9.12816 13.435 5.56497C9.87184 2.00178 5.03912 9.81151e-07 4.52995e-06 0L0 38Z" fill="url(#paint1_linear_22_5890)" />
                                <defs>
                                    <linearGradient id="paint0_linear_22_5890" x1="1.26666" y1="38" x2="28.4364" y2="-5.91666" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#E5762C" />
                                        <stop offset="1" stop-color="#B6CCF7" />
                                    </linearGradient>
                                    <linearGradient id="paint1_linear_22_5890" x1="1.26666" y1="38" x2="28.4364" y2="-5.91666" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#E5762C" />
                                        <stop offset="1" stop-color="#B6CCF7" />
                                    </linearGradient>
                                </defs>
                            </svg>


                            <span className="font-semibold text-[13px] text-[#212326] whitespace-nowrap">
                                {item}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}